import { render, staticRenderFns } from "./CompanionPricePosition.vue?vue&type=template&id=c15bdb0c&"
import script from "./CompanionPricePosition.vue?vue&type=script&lang=js&"
export * from "./CompanionPricePosition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports